import Button from '@components/button';
import type { ButtonColor } from '@components/button/button.view';
import classNames from 'classnames';
import { Theme } from 'constants/colors';
import Link from 'next/link';
import type { ReactElement } from 'react';
import React, { useMemo } from 'react';
import type { CTA } from 'types/components/cta';
import { validateString } from 'utils/validate-string';

import styles from './calls-to-action.module.scss';

interface Props {
  readonly primaryCta?: CTA | undefined;
  readonly secondaryCta?: CTA | undefined;
  readonly theme?: Theme | undefined;
}

const ctaContainerClass = validateString(styles.ctaContainer);

export default function CallsToAciton({
  primaryCta,
  secondaryCta,
  theme,
}: Props): ReactElement | null {
  const primaryColor: ButtonColor = useMemo((): ButtonColor => {
    if (typeof theme === 'undefined') {
      return 'primary';
    }

    if (theme === Theme.Primary100) {
      return 'secondary';
    }

    return 'primary';
  }, [theme]);

  const secondaryColor: ButtonColor = useMemo((): ButtonColor => {
    if (typeof theme === 'undefined') {
      return 'secondary';
    }

    if (theme === Theme.Primary100) {
      return 'secondary';
    }

    return 'primary';
  }, [theme]);
  if (
    typeof primaryCta === 'undefined' &&
    typeof secondaryCta === 'undefined'
  ) {
    return null;
  }

  return (
    <div className={classNames(ctaContainerClass, theme)}>
      {typeof primaryCta !== 'undefined' && (
        <Link href={primaryCta.url}>
          <Button color={primaryColor} variant="solid">
            {primaryCta.label}
          </Button>
        </Link>
      )}
      {typeof secondaryCta !== 'undefined' && (
        <Link href={secondaryCta.url}>
          <Button color={secondaryColor} variant="outline">
            {secondaryCta.label}
          </Button>
        </Link>
      )}
    </div>
  );
}
